<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <div class="title">体验仓记录查询</div>
      <el-tabs v-model="recordType" @tab-click="resetAndFetch">
        <el-tab-pane v-for="(config, type) in records" :key="type" :label="config.label" :name="type" />
      </el-tabs>
      <div class="filters">
        <el-input v-model.trim="filters.userId" size="mini" clearable placeholder="用户UID" />
        <el-select v-model="filters.symbolId" size="mini" clearable filterable placeholder="交易对">
          <el-option v-for="item in symbols" :key="item.symbolId" :label="item.symbol" :value="item.symbolId" />
        </el-select>
        <el-input v-model.trim="filters.positionId" size="mini" clearable placeholder="仓位ID" />
        <el-input v-if="recordType === 'ORDER_HISTORY'" v-model.trim="filters.orderId" size="mini" clearable placeholder="订单ID" />
        <el-input v-if="isEntrust" v-model.trim="filters.entrustId" size="mini" clearable placeholder="止盈止损ID" />
        <el-date-picker v-model="filters.timeRange" size="mini" type="datetimerange" value-format="timestamp" start-placeholder="开始时间" end-placeholder="结束时间" />
        <el-button size="mini" type="primary" @click="resetAndFetch">查询</el-button>
        <el-button size="mini" @click="resetFilters">重置</el-button>
        <el-button size="mini" :loading="exporting" @click="exportData">导出</el-button>
      </div>

      <el-table v-loading="loading" :data="items" size="mini" height="calc(100vh - 350px)">
        <el-table-column prop="userId" label="用户UID" min-width="110" />
        <el-table-column v-if="isPosition" prop="positionId" label="仓位ID" min-width="120" />
        <el-table-column v-if="recordType === 'ORDER_HISTORY'" prop="orderId" label="订单ID" min-width="120" />
        <el-table-column v-if="isEntrust" prop="entrustId" label="止盈止损ID" min-width="130" />
        <el-table-column v-if="!isPosition" prop="positionId" label="仓位ID" min-width="120" />
        <el-table-column prop="symbol" label="交易对" min-width="100" />
        <el-table-column v-if="isPosition || recordType === 'ORDER_HISTORY'" prop="positionSide" label="方向" width="80"><template slot-scope="s">{{ sideText(s.row.positionSide) }}</template></el-table-column>
        <el-table-column v-if="isPosition" prop="leverage" label="杠杆" width="70"><template slot-scope="s">{{ s.row.leverage }}X</template></el-table-column>
        <el-table-column v-if="isPosition" prop="principalAmount" label="体验本金" min-width="100" />
        <el-table-column v-if="isPosition" prop="positionQuantity" label="仓位数量" min-width="100" />
        <el-table-column v-if="isPosition" prop="entryPrice" label="开仓价" min-width="100" />
        <el-table-column v-if="isPosition" prop="markPrice" label="标记价快照" min-width="115"><template slot-scope="s"><span :class="{ stale: s.row.priceStale }">{{ s.row.markPrice == null ? '-' : s.row.markPrice }}{{ s.row.priceStale ? '（过期）' : '' }}</span></template></el-table-column>
        <el-table-column v-if="isPosition" prop="unrealizedPnl" label="未实现盈亏" min-width="105" />
        <el-table-column v-if="isPosition" prop="realizedPnl" label="已实现盈亏" min-width="105" />
        <el-table-column v-if="recordType === 'ORDER_HISTORY'" prop="operationType" label="操作" width="80" />
        <el-table-column v-if="recordType === 'ORDER_HISTORY'" prop="executionPrice" label="成交价" min-width="100" />
        <el-table-column v-if="recordType === 'ORDER_HISTORY'" prop="quantity" label="成交数量" min-width="100" />
        <el-table-column v-if="isEntrust" prop="entrustType" label="类型" min-width="100"><template slot-scope="s">{{ entrustTypeText(s.row.entrustType) }}</template></el-table-column>
        <el-table-column v-if="isEntrust" prop="triggerPrice" label="触发价" min-width="100" />
        <el-table-column v-if="isEntrust" prop="quantity" label="数量" min-width="90" />
        <el-table-column prop="status" label="状态" min-width="100" />
        <el-table-column v-if="isPosition" prop="openTime" label="开仓时间" min-width="160"><template slot-scope="s">{{ s.row.openTime | moment }}</template></el-table-column>
        <el-table-column v-if="recordType === 'POSITION_HISTORY'" prop="closeTime" label="平仓时间" min-width="160"><template slot-scope="s">{{ s.row.closeTime | moment }}</template></el-table-column>
        <el-table-column v-if="recordType === 'ORDER_HISTORY'" prop="createdTime" label="创建时间" min-width="160"><template slot-scope="s">{{ s.row.createdTime | moment }}</template></el-table-column>
        <el-table-column v-if="isEntrust" prop="createdTime" label="创建时间" min-width="160"><template slot-scope="s">{{ s.row.createdTime | moment }}</template></el-table-column>
        <el-table-column v-if="isEntrust" prop="updatedTime" label="更新时间" min-width="160"><template slot-scope="s">{{ s.row.updatedTime | moment }}</template></el-table-column>
      </el-table>
      <div class="cursor-page">
        <el-button size="mini" :disabled="pageIndex === 0" @click="previousPage">上一页</el-button>
        <span>第 {{ pageIndex + 1 }} 页</span>
        <el-button size="mini" :disabled="!hasNext" @click="nextPage">下一页</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import api, { RECORDS } from './api'
import couponApi from '../Coupon/api'

const emptyFilters = () => ({ userId: '', symbolId: '', positionId: '', orderId: '', entrustId: '', timeRange: [] })
export default {
  name: 'WelfareExperiencePosition',
  data() {
    return { records: RECORDS, recordType: 'CURRENT_POSITION', filters: emptyFilters(), symbols: [], items: [], loading: false, exporting: false, hasNext: false, nextTime: null, nextId: null, pageIndex: 0, cursors: [{ beforeTime: null, beforeId: null }] }
  },
  computed: {
    isPosition() { return this.recordType === 'CURRENT_POSITION' || this.recordType === 'POSITION_HISTORY' },
    isEntrust() { return this.recordType === 'CURRENT_ENTRUST' || this.recordType === 'ENTRUST_HISTORY' },
  },
  created() {
    couponApi.positionOptions().then((res) => { if (res && res.code === 0) this.symbols = res.data || [] })
    this.fetchList()
  },
  methods: {
    sideText(value) { return value === 'LONG' ? '多' : value === 'SHORT' ? '空' : value || '-' },
    entrustTypeText(value) { return value === 'TAKE_PROFIT' ? '止盈' : value === 'STOP_LOSS' ? '止损' : value || '-' },
    buildQuery(includeCursor = true) {
      const query = { size: 10 }
      ;['userId', 'symbolId', 'positionId', 'orderId', 'entrustId'].forEach((key) => { if (this.filters[key] !== '') query[key] = this.filters[key] })
      if (this.filters.timeRange && this.filters.timeRange.length === 2) { query.startTime = this.filters.timeRange[0]; query.endTime = this.filters.timeRange[1] }
      if (includeCursor && this.pageIndex > 0) { const c = this.cursors[this.pageIndex]; query.beforeTime = c.beforeTime; query.beforeId = c.beforeId }
      return query
    },
    fetchList() {
      this.loading = true
      api.list(this.recordType, this.buildQuery()).then((res) => {
        if (res && res.code === 0) { const d = res.data || {}; this.items = d.items || []; this.hasNext = !!d.hasNext; this.nextTime = d.nextTime; this.nextId = d.nextId }
        else { this.items = []; this.$message.error((res && res.msg) || '查询失败') }
      }).finally(() => { this.loading = false })
    },
    resetAndFetch() { this.pageIndex = 0; this.cursors = [{ beforeTime: null, beforeId: null }]; this.fetchList() },
    resetFilters() { this.filters = emptyFilters(); this.resetAndFetch() },
    nextPage() { this.cursors[this.pageIndex + 1] = { beforeTime: this.nextTime, beforeId: this.nextId }; this.pageIndex += 1; this.fetchList() },
    previousPage() { this.pageIndex -= 1; this.fetchList() },
    exportData() {
      this.exporting = true
      api.exportFile({ ...this.buildQuery(false), recordType: this.recordType }).then((blob) => {
        const url = URL.createObjectURL(blob); const link = document.createElement('a'); link.href = url; link.download = `${RECORDS[this.recordType].label}.xlsx`; link.click(); URL.revokeObjectURL(url)
      }).finally(() => { this.exporting = false })
    },
  },
}
</script>

<style lang="less" scoped>
.title { margin-bottom: 8px; font-size: 16px; font-weight: 600; }
.filters { display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 12px; }
.filters > .el-input, .filters > .el-select { width: 145px; }
.cursor-page { display: flex; justify-content: center; align-items: center; gap: 12px; margin-top: 12px; }
.stale { color: #e6a23c; }
</style>
